import { LDProps } from '../../../skeleton/src/core/providers/launch-darkly';

export function hasConsolidationSheetsImportEnabled(flags: LDProps['flags']): boolean {
  return flags?.consolidationSheetsImport ?? false;
}
